import { HTTPErrorCode } from '@shared/HttpInterceptors/HTTP_ERROR_CODES';

const wasSchedulesProblemAlreadyReported = (errorCode?: HTTPErrorCode) =>
  errorCode && errorCode === HTTPErrorCode.SCHEDULE_PROBLEM_ALREADY_REPORTED;

const wereSchedulesAlreadyValidated = (errorCode?: HTTPErrorCode) =>
  errorCode && errorCode === HTTPErrorCode.SCHEDULES_ALREADY_VALIDATED;

export { wasSchedulesProblemAlreadyReported, wereSchedulesAlreadyValidated };
